import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function promocode(state = initialState.promocode, action) {
  switch(action.type) {
    case types.ACTIVATE_PROMOCODE_REQUEST:
      return Object.assign({}, state, {
        //   isFetching: true,
      });
      
    case types.ACTIVATE_PROMOCODE_SUCCESS:
      return Object.assign({}, state, {
        data: action.data
        //   isFetching: false,
      })
      
    case types.ACTIVATE_PROMOCODE_FAILURE:
      return Object.assign({}, state, {
        errorMessages: action.messages
        //   isFetching: false,
      })
      
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/promocodeReducer.js